import {getCookieByName, setCookieByName, deleteAllCookies} from "vendor/application";
import {getAdminLayouts} from "@helpers";
import { v4 as uuid } from "uuid";

/**
 * Este fichero contiene el reducer principal de nuestra aplicación.
 * Basándonos en los tipos de las acciones, se realizaran modificaciones
 * sobre el estado inicial
 */
var access = getCookieByName("b__ac");
var actualProject = getCookieByName("b__ap");
var actualLayout = getCookieByName("b__ly_m");
var deviceID = getCookieByName("b__di");

if (!deviceID ) {
    deviceID = uuid();
}
setCookieByName(deviceID, "b__di");

// Estado inicial de nuestra aplicación
const initialState = {
    access: {access: "", refresh: "", isAccess: false, userId: ""},
    notify: {message: "", severity: "", type: "", from: "", isNotify: false},
    initApp: false,
    isSending: false,
    isDeleting: false,
    actualLayout: {},
    actualProject: {},
    layouts: getAdminLayouts(),
    projects: {},
    user: {},
    device_id: deviceID,
    plan: {},
    plans: {}
};

/**
 * El reducer recibe el estado actual y la acción a ejecutar. Si el estado
 * no está definido, obtenemos el estado por defecto
 */

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case "UPDATE_ACCESS_STATUS": {
            setCookieByName(action.data, "b__ac");
            return Object.assign({}, state, {
                access: action.data
            });
        }

        case "UPDATE_USER": {
            return Object.assign({}, state, {
                user: action.data
            });
        }

        case "UPDATE_PLAN": {
            return Object.assign({}, state, {
                plan: action.data
            });
        }

        case "UPDATE_PLANS": {
            return Object.assign({}, state, {
                plans: action.data
            });
        }

        case "UPDATE_SENDING": {
            return Object.assign({}, state, {
                isSending: action.data
            });
        }

        case "UPDATE_ACTUAL_LAYOUT": {
            setCookieByName(action.data, "b__ly_m");
            return Object.assign({}, state, {
                actualLayout: action.data
            });
        }

        case "UPDATE_DELETING": {
            return Object.assign({}, state, {
                isDeleting: action.data
            });
        }

        case "UPDATE_PROJECTS": {
            return Object.assign({}, state, {
                projects: action.data
            });
        }

        case "UPDATE_INIT_APP": {
            return Object.assign({}, state, {
                initApp: action.data
            });
        }

        case "SHOW_NOTIFY": {
            return Object.assign({}, state, {
                notify: {
                    message: action.data.message,
                    severity: action.data.severity,
                    isNotify: true,
                    from: action.data.from,
                    type: action.data.type
                }
            });
        }

        case "HIDE_NOTIFY": {
            return Object.assign({}, state, {
                notify: {
                    message: action.data.message,
                    severity: action.data.severity,
                    isNotify: false,
                    from: action.data.from,
                    type: action.data.type
                }
            });
        }

        case "RESET_STATE": {
            deleteAllCookies();
            return initialState;
        }

        default: {
            if (access) {
                state = {...state, access};
            }
            if (actualProject) {
                state = {...state, actualProject};
            }
            if (actualLayout) {
                state = {...state, actualLayout};
            }
            return state;
        }
    }
};

export default reducer;
